module.exports = __webpack_public_path__ + "img/tip.69c6fbfc.png";